export default {
    MOVED_OUT_CONTAINER: 0.3,
    MAX_SCALE: 1.5,
    MIN_SCALE: 0.7,
    SCALE_STEP: 0.1,
};
